import { FilterFilled } from "@ant-design/icons";
import { Button, Checkbox, Divider, Space } from "antd";

export const getColumnFilterProps = (dataIndex, filter, setFilter, options) => {
    const CheckboxGroup = Checkbox.Group;

    const handleApplyFilter = (columnKey, selectedValues, close) => {
        setFilter((prev) => ({
            ...prev,
            [columnKey]: selectedValues
        }))
        close();
    };

    const handleResetFilter = (columnKey, clearFilters, close) => {
        setFilter((prev) => (
            {
                ...prev,
                [columnKey]: []
            }
        ))
        clearFilters();
        close();
    };

    return {
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div style={{ padding: 8 }}>
                <CheckboxGroup
                    options={options.map((item) => {
                        return {
                            label: item.label ? item.label : item.status, value: item.value ? item.value : item.status
                        }
                    })}
                    className='gap-1'
                    style={{ display: "flex", flexDirection: "column" }}
                    value={selectedKeys.length ? selectedKeys : filter[dataIndex]}
                    onChange={(values) => setSelectedKeys(values)}
                />
                <Divider className='my-2' />
                <Space className='d-flex flex-row justify-content-end'>
                    <Button type="link" disabled={filter[dataIndex].length > 0 ? false : true} onClick={() => handleResetFilter(dataIndex, clearFilters, close)} size="small">
                        Reset
                    </Button>
                    <Button
                        type="primary"
                        onClick={() => handleApplyFilter(dataIndex, selectedKeys, close)}
                        size="small"
                    >
                        Apply
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: () => {
            let isFilter = filter[dataIndex].length > 0;
            return (
                <FilterFilled style={{ color: isFilter && '#1677ff' }} />
            )
        }
    }
};